import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* uploadLinkPreview({ payload: { formData, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.linkImageUploader, data: formData, useV1: true });
    
    onSuccess && onSuccess(data);
    yield put(actions.uploadLinkPreviewDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.uploadLinkPreviewFailed,
      handledErrors,
      endpoint: api.linkImageUploader.url
    });
  }
}

export const uploadLinkPreviewSaga = takeEvery(types.UPLOAD_LINK_PREVIEW_REQUEST, uploadLinkPreview);
